module.exports = __webpack_public_path__ + "fonts/fa-regular-400.8b892b7.woff";